import React from "react";
import Link from "next/link";
import Box from "@mui/material/Box";
import dayjs from "dayjs";

import { Medication } from "@/interfaces/IServiceUser";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { setSelectedVisit } from "@/redux/reducers/roster";
import { medicationTypeLabel } from "@/utils/constants";
import ListView from "../list";
import { DrawerStyled } from "./drawerStyled";

type Props = {
  medications: Medication[];
  medicationLoading: boolean;
};
// /service/medication/66b45eabd94cd70d53235741/medication-list
function Medications({ medicationLoading, medications }: Props) {
  const dispatch = useAppDispatch();
  const { selectedVisit } = useAppSelector((state) => state.roster);

  const date = selectedVisit?.start;
  const user = selectedVisit?.extendedProps?.serviceUser?._id;

  const closeDrawer = () => {
    dispatch(setSelectedVisit(null));
  };

  const renderItem = (med: Medication) => {
    const hasMultipleTimes =
      med.timePeriod?.length > 0 || med.specificTime?.length > 0;

    if (!hasMultipleTimes) {
      return (
        <Link
          href={`/service/medication/${encodeURIComponent(user)}/medication-list?id=${encodeURIComponent(med._id)}`}
          onClick={closeDrawer}
        >
          <Box className="medication-user-Detail">
            <span className="medication-user">{med.medicine}</span>
            <span className="time">
              {medicationTypeLabel?.[med.type] || med.type}
            </span>
          </Box>
        </Link>
      );
    }

    const hasTimePeriods = med.timePeriod?.length > 0;
    if (hasTimePeriods) {
      return med.timePeriod.map((item, i) => (
        <Link
          href={`/service/medication/${encodeURIComponent(user)}/medication-list?id=${encodeURIComponent(med._id)}`}
          key={i}
          onClick={closeDrawer}
        >
          <Box className="medication-user-Detail">
            <span className="medication-user">{med.medicine}</span>
            <span className="time">{item}</span>
          </Box>
        </Link>
      ));
    }

    return med.specificTime
      .filter((el) => dayjs(el).isSame(dayjs(date), "minute"))
      .map((item, i) => (
        <Link
          href={`/service/medication/${encodeURIComponent(user)}/medication-list?id=${encodeURIComponent(med._id)}`}
          key={i}
          onClick={closeDrawer}
        >
          <Box className="medication-user-Detail" key={i}>
            <span className="medication-user">{med.medicine}</span>
            <span className="time">{dayjs(item).utc().format("HH:mm")}</span>
          </Box>
        </Link>
      ));
  };

  return (
    <DrawerStyled>
      <Box className="Activities">
        <ListView
          data={medications}
          loading={medicationLoading}
          renderItem={renderItem}
        />
      </Box>
    </DrawerStyled>
  );
}

export default Medications;
